export const POSITION_MANAGERS_WITH_SWELL_REWARD = [
  {
    identifier: '0x2b0Ca7A851aAc56fcACAB3ee85B8Dd96DE799aCa',
  },
] as const
